// extracted by mini-css-extract-plugin
export default {"ErrorPage":"ErrorPage__NAO1k2KL"};